import { lazy } from "react";

export const gameRoutes = [
  // {
  //   path: "/games/shark-tower",
  //   component: lazy(() => import("@/pages/Games/SharkTower")),
  // },
  // {
  //   path: "/games/spin-wheel",
  //   component: lazy(() => import("@/pages/Games/SpinWheel")),
  // },
  // {
  //   path: "/games/bay-catch",
  //   component: lazy(() => import("@/pages/Games/BayCatch")),
  // },
  // {
  //   path: "/games/shark-drift",
  //   component: lazy(() => import("@/pages/Games/SharkDrift")),
  // },
  // {
  //   path: "/games/marine-mystique",
  //   component: lazy(() => import("@/pages/Games/MarineMystique")),
  // },
  // {
  //   path: "/games/predators-pick",
  //   component: lazy(() => import("@/pages/Games/PredatorsPick")),
  // },
];

export const iframeRoutes = [
  {
    path: "/games/iframe/spin-wheel",
    component: lazy(() => import("@/pages/Games/IFrames/SpinWheel")),
  },
  {
    path: "/games/iframe/shark-tower",
    component: lazy(() => import("@/pages/Games/IFrames/SharkTower")),
  },
  {
    path: "/games/iframe/bay-catch",
    component: lazy(() => import("@/pages/Games/IFrames/BayCatch")),
  },
];
